module.exports = __webpack_public_path__ + "static/media/header.1e631f0b.png";